module.exports = __webpack_public_path__ + "assets/img/thumb-Smart-Structuring-Landing-Page-+-Website.e874a9f1.webp";